module.exports = __webpack_public_path__ + "img/payment-success.520885fd.svg";